/**
 * Theme Configuration
 * 
 * Centralized theme definitions for the application.
 * 
 * HOW TO ADD A NEW THEME:
 * 1. Add the theme ID here in THEME_IDS
 * 2. Create the theme class in themes.scss with all required CSS variables
 * 
 * HOW TO ADD A NEW A11Y MODE:
 * 1. Add the mode here in COLOR_VISION_TYPES
 * 2. Add the mode class in _a11y-system.scss with hue shifts for problematic colors
 */

export const THEME_IDS = {
  DEFAULT: { ID: 'theme-default', Label: 'LDI (Default)', Type: 'light' },
  WHITE: { ID: 'theme-white', Label: 'Moon White', Type: 'light' },
  DARK: { ID: 'theme-dark', Label: 'Dark', Type: 'dark' },
  SLATE: { ID: 'theme-slate', Label: 'Slate', Type: 'dark' },
  AMBER: { ID: 'theme-amber', Label: 'Amber', Type: 'dark' },
  HIGH_CONTRAST: { ID: 'theme-high-contrast', Label: 'High Contrast', Type: 'dark' },
};

export const COLOR_VISION_TYPES = {
  DEFAULT: { ID: '', Label: 'Default' },
  RED_GREEN: { ID: 'a11y-red-green', Label: 'Red-Green (Deuteranopia/Protanopia)' },
  BLUE_YELLOW: { ID: 'a11y-blue-yellow', Label: 'Blue-Yellow (Tritanopia)' },
};

export const DEFAULT_THEME = 'theme-default';
export const THEME_TYPE = null;

export const isValidTheme = (themeID) => {
  return Object.values(THEME_IDS).map(theme => theme.ID).includes(themeID);
};

export const isValidColorVisionType = (type) => {
  return Object.values(COLOR_VISION_TYPES).map(typeObj => typeObj.ID).includes(type);
};

export const getThemeType = (themeID) => {
  const theme = Object.values(THEME_IDS).find(theme => theme.ID === themeID);
  return theme ? theme.Type : 'light';
};  
